import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";
import "../styles/Wissenswertes.css";
import styles from '../styles/Wissenswertes.module.css'

const Wissenswertes = () => {
  const { accessToken, user } = useAuth();
  const isLoggedIn = !!user;
  const isModerator = isLoggedIn;
  const [wissenswertesData, setWissenswertesData] = useState([]);
  const [loadingWissenswertes, setLoadingWissenswertes] = useState(true);
  const [errorWissenswertes, setErrorWissenswertes] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [hidePublic, setHidePublic] = useState(false);
  const [hideModerator, setHideModerator] = useState(false);
  const [hiddenSection, setHiddenSection] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [activeTopOffset, setActiveTopOffset] = useState(-100);
  const sections = useRef([]);

  const moderatorInfo = isModerator ? "" : "&filter[Moderator][_neq]=true";
  const Wissenswertes_API_URL = process.env.REACT_APP_API_BASE_URL + '/items/Wissenswertes?fields=*&filter[status][_eq]=published' + moderatorInfo;

  const toggleHidePublic = () => {
    if (hidePublic === false) {
      setHidePublic(true);
      setHideModerator(false);
    } else {
      setHidePublic(false);
    }
  };

  const toggleHideModerator = () => {
    if (hideModerator === false) {
      setHideModerator(true);
      setHidePublic(false);
    } else {
      setHideModerator(false);
    }
  };

  const scrollToSection = (id, active) => {
      const element = document.getElementById(id);
      if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
  };

  const scrollActiveSlider = (active) => {
    setActiveTopOffset(active.offsetTop + 3);
  }

  /* const handleInputChange = () => {
    wissenswertesData = wissenswertesData.filter(element => {
        return element.name.toLowerCase().includes(query.toLowerCase());
      })
  } */

  useEffect(() => {
    const fetchWissenswertes = async () => {
      try {
        const response = await axios.get(Wissenswertes_API_URL);
          if (response.data && response.data.data) {
            setWissenswertesData(response.data.data);
          } else {
            setErrorWissenswertes('Нет данных для отображения');
          }
        } catch (error) {
          setErrorWissenswertes('Ошибка при получении данных');
          console.error(error);
        } finally {
          setLoadingWissenswertes(false);
        }
      };

      fetchWissenswertes();
  }, []);

  const handleScroll = () => {
      const pageYOffset = window.scrollY;
      let newActiveSection = null;
      let newActiveNav = document.querySelectorAll('[data-active="true"]')[0];

      sections.current = document.querySelectorAll('[data-section]');

      sections.current.forEach((section) => {
          const sectionOffsetTop = section.offsetTop;
          const sectionHeight = section.offsetHeight;

          if (pageYOffset >= (sectionOffsetTop - 300) && pageYOffset < (sectionOffsetTop - 300) + sectionHeight) {
              newActiveSection = section.id;
              /* console.log(document.querySelectorAll('[data-active="true"]')[0].offsetTop); */
              
          }
      });

      (newActiveNav) ?  setActiveTopOffset(newActiveNav.offsetTop + 3) : setActiveTopOffset(-100);
      setActiveSection(newActiveSection);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll);

      return () => {
          window.removeEventListener('scroll', handleScroll);
      };
  }, []);

  return (
    <>
      <header className={styles['info-header']}>
        <div className={styles.container}>
          <h1>Wissenswertes</h1>
          <div className={styles['info-search']}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--primary-text-color)"><path d="M380-320q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l224 224q11 11 11 28t-11 28q-11 11-28 11t-28-11L532-372q-30 24-69 38t-83 14Zm0-80q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
            <input type="search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}></input>
          </div>
          {isModerator && (
            <div className={styles['info-moderator']}>
              <a className={`${styles['view-button']} ${hidePublic ? 'hidden' : ''}`} onClick={() => toggleHidePublic(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm120-80h200q17 0 28.5-11.5T560-320q0-17-11.5-28.5T520-360H320q-17 0-28.5 11.5T280-320q0 17 11.5 28.5T320-280Zm0-160h320q17 0 28.5-11.5T680-480q0-17-11.5-28.5T640-520H320q-17 0-28.5 11.5T280-480q0 17 11.5 28.5T320-440Zm0-160h320q17 0 28.5-11.5T680-640q0-17-11.5-28.5T640-680H320q-17 0-28.5 11.5T280-640q0 17 11.5 28.5T320-600Zm181.5-198.5Q510-807 510-820t-8.5-21.5Q493-850 480-850t-21.5 8.5Q450-833 450-820t8.5 21.5Q467-790 480-790t21.5-8.5ZM200-200v-560 560Z"/></svg>
              </a>
              <a className={`${styles['view-button']} ${hideModerator ? 'hidden' : ''}`} onClick={() => toggleHideModerator(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q14-36 44-58t68-22q38 0 68 22t44 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm301.5-678.5Q510-807 510-820t-8.5-21.5Q493-850 480-850t-21.5 8.5Q450-833 450-820t8.5 21.5Q467-790 480-790t21.5-8.5ZM200-246q54-53 125.5-83.5T480-360q83 0 154.5 30.5T760-246v-514H200v514Zm379-235q41-41 41-99t-41-99q-41-41-99-41t-99 41q-41 41-41 99t41 99q41 41 99 41t99-41ZM280-200h400v-10q-42-35-93-52.5T480-280q-56 0-107 17.5T280-210v10Zm157.5-337.5Q420-555 420-580t17.5-42.5Q455-640 480-640t42.5 17.5Q540-605 540-580t-17.5 42.5Q505-520 480-520t-42.5-17.5ZM480-503Z"/></svg>
              </a>
            </div>
          )}
        </div>
      </header>
      <div className={styles.container}>
        {!loadingWissenswertes && !errorWissenswertes && (
          <>
            <nav className={styles['info-nav']}>
              <ul>
                { wissenswertesData
                  .filter((info) => info.Kurzname.toLowerCase().includes(searchQuery.toLowerCase()) || info.Headline.toLowerCase().includes(searchQuery.toLowerCase()) || info.Content.toLowerCase().includes(searchQuery.toLowerCase()))
                  .map((info, idx) => {
                    return (((!hideModerator && info.Moderator) || (!hidePublic && !info.Moderator )) &&
                      <li key={idx}>
                        <button
                          type="button"
                          className={(activeSection === info.Kurzname) ? 'active' : ''}
                          onClick={(e) => scrollToSection(info.Kurzname, e.target)}
                          onChange={(e) => scrollActiveSlider(e.target)}
                          data-active={(activeSection === info.Kurzname) ? 'true' : 'false'}>
                        {info.Kurzname}</button>
                      </li>
                    )})
                  }
              </ul>
              <div className={styles['active-slider']} style={{top: `${activeTopOffset}px`}}></div>
            </nav>
            <main>
              { wissenswertesData
                .filter((info) => info.Kurzname.toLowerCase().includes(searchQuery.toLowerCase()) || info.Headline.toLowerCase().includes(searchQuery.toLowerCase()) || info.Content.toLowerCase().includes(searchQuery.toLowerCase()))
                .map((info, idx) => {
                  return (((!hideModerator && info.Moderator) || (!hidePublic && !info.Moderator )) &&
                    <div key={idx} className={`${styles['info-block']} ${info.Moderator && styles['is-moderator']}`} id={info.Kurzname} data-section>
                      <div className={styles['info-container']}>
                        <h2 className={styles['info-title']}>{info.Headline}</h2>
                        <div className={styles['info-content']} dangerouslySetInnerHTML={{__html:info.Content}} />
                      </div>
                    </div>
                  )})
                }
            </main>
          </>
        )}
      </div>
    </>
  )
}

export default Wissenswertes;